<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-button
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              class="ml-3"
              @click="getAllBillingRejectionLogList('Excel')"
              size="sm"
              variant="outline-info"
              >{{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        @input="debounceSearch"
                        v-model="filter"
                        placeholder="Type to Search Module Master"
                        ref="search"
                      />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2"
                  ><h5>
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5></b-col
                >
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="RTBIList"
                  responsive
                  :fields="Columns"
                  primary-key="id_email_section"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                  class="position-relative"
                >
                  <template slot="SN" slot-scope="row0">
                    <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="5"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";
import CommonService from "../../services/CommonService.js";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/billRejectionDash");
      if (globalPermissionStatus("Dashboard_Access")) {
        this.getAllBillingRejectionLogList("Normal");
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export As Excel",
      isLoading: false,
      selectDateFormat,
      Columns: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "JobType",
          mainkey: "JobType",
          label: "Job Type",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "JobTypeStr",
          mainkey: "JobTypeStr",
          label: "All Job Type",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "JOB NO",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "UserName",
          mainkey: "UserName",
          label: "Rejected User Name",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "RejectedDate",
          mainkey: "RejectedDate",
          label: "Rejected Date",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "log_comment",
          mainkey: "log_comment",
          label: "Reason",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "feedback",
          mainkey: "feedback",
          label: "Feedback",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "log_message",
          mainkey: "log_message",
          label: "MSG",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
      ],
      docURL: URL_BASE_DOC,
      currentPage: 1,
      perPage: 50,
      totalRows: "",
      sortBy: null,
      sortDesc: false,
      pageOptions: [5, 10, 15],
      adminToggle: this.$sessionsStorage.get(),
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      RTBIList: [],
      visible: false,

      adminToggle: this.$sessionsStorage.get("designation"),
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    ClientUserService,
    CommonService,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  methods: {
    getAllBillingRejectionLogList(type) {
      this.isLoading = true;
      this.RTBIList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getJobRTBIDetails",
        type: type,
      };

      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.RTBIListFLAG == 1) {
            if (type == "Excel") {
              if (data.RTBIList.length > 0) {
                this.RTBIList = data.RTBIList;
              }
              this.ExcelBtnName = "Export As Excel";
               this.totalRows=data.RTBIList.length;
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.RTBIList.length > 0) {
                this.RTBIList = data.RTBIList;
                this.totalRows=data.RTBIList.length;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on RTBIList Error: ", error);
        });
    },
    goBack() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllBillingRejectionLogList("Normal");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getAllBillingRejectionLogList("Normal");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// billingRejectionDash.vue?2f0ad13a